import contract from '@mailobj-browser/front/js/contracts/contract.js'

import main from './main/main.js'
import send from './send/send.js'

export default contract({
  main,
  send
})
